import axios from "axios";

const API_BASE = "https://technglobaladmin-portal-a0s8.onrender.com";
// const API_BASE = "http://localhost:5001";

export const fetchUsers = () => axios.get(`${API_BASE}/api/users`);
export const updateUserStatus = (id, status) =>
  axios.put(`${API_BASE}/api/users/${id}/status`, { status });


// api/adminApi.js
// DELETE user
export const deleteUser = (id) => axios.delete(`${API_BASE}/api/users/${id}`);

// export const fetchCourses = () => axios.get(`${API_BASE}/api/videos`);

// export const updateUserCourse = (id, course_name) =>
//   axios.put(`${API_BASE}/api/users/${id}/course`, { course_name }); 

// Fetch unique course names from user_progress table


// 🔹 Update user's selected course
export const fetchCourses = () => {
  return axios.get(`${API_BASE}/api/users/courses/list`);
};

// Update a user's course (PUT)
export const updateUserCourse = (userId, newCourse) => {
  return axios.put(`${API_BASE}/api/users/${userId}/course`, {
    course_name: newCourse,
  });
};

